document.addEventListener("DOMContentLoaded", function () {
  // Get all accordion items
  const accordionItems = document.querySelectorAll(".accordion-item");

  // Add click event listener to each accordion header
  accordionItems.forEach((item) => {
    const header = item.querySelector(".accordion-header");
    const content = item.querySelector(".accordion-content");

    header.addEventListener("click", () => {
      // Toggle the 'expanded' class on content
      content.classList.toggle("expanded");
      header.classList.toggle("open-accordion");

      // Collapse other accordion items
      accordionItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem
            .querySelector(".accordion-content")
            .classList.remove("expanded");
          otherItem
            .querySelector(".accordion-header")
            .classList.remove("open-accordion");
        }
      });
    });
  });
});


// satrt banner slider code
jQuery(".ss-saying-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: true,
  autoplay: true,
  // centerPadding: '109px',
  speed: 1000,
  loop: true,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
  ],
});

jQuery(".shop-catogery-slider").slick({
  slidesToShow: 3, // Number of slides to show at a time
  slidesToScroll: 1, // Number of slides to scroll at a time
  autoplay: true, // Autoplay enabled
  autoplaySpeed: 3000, // Autoplay speed in milliseconds
  prevArrow: '<button type="button" class="slick-prev">Previous</button>', // Custom previous arrow
  nextArrow: '<button type="button" class="slick-next">Next</button>', // Custom next arrow
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1, // Adjust number of slides to show on smaller screens
      },
    },
  ],
});

// Select the anchor tag within the second list item and add target="_blank" attribute
//jQuery(".list-menu li:nth-child(3) ul li a").attr("target", "_blank");

jQuery(".quicks-suplement-facts-table-content").slick({
        dots: true,
        autoplay:true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
});